import Request from "./request";

export default class ArticleHistory {
	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return (this._instance = new ArticleHistory());
	}

	getArticleHistoryList(articleId) {
		return Request.instance().get('/article/history/list/' + articleId);
	}

	getArticleHistory(historyId) {
		return Request.instance().get('/article/history/' + historyId);
	}
}